import React from "react";
import { PropertyWrapper } from "./Cards.styled";
import { Box } from "../primitives";
import { FiArrowRight } from "react-icons/fi";
import { CardSelected } from "../../type";
import { useAddCommas } from "../../utils";

interface QuantityProps {
  card: CardSelected;
}

export const Quantity = ({ card }: QuantityProps) => {
  const addCommas = useAddCommas();
  return (
    <PropertyWrapper>
      {card?.originalQuantity && card?.originalQuantity !== card?.quantity && (
        <>
          <Box css={{ textDecoration: "line-through" }}>
            {addCommas(card.originalQuantity)}
          </Box>
          <FiArrowRight size={18} />
        </>
      )}
      <Box>{card.quantity}x</Box>
    </PropertyWrapper>
  );
};
